import { Button, styled } from "@mui/material";

export const LinkoutButton = styled(Button)({
    textAlign: "right",
    textTransform: "none",
    marginTop: "-0.5rem",
    fontSize: "1rem",
    lineHeight: 1.5,
    padding: 0,
    letterSpacing: "normal",
    color: "var(--community-color-bright-azure)",
    gap: "0.5rem",
    "& svg": {
        width: "auto",
        height: "0.75rem",
        fill: "var(--community-color-bright-azure)",
    },
});

export const LinkoutButtonText = styled("span")({
    fontWeight: 400,
    fontFamily:
        'system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", Segoe UI Symbol !important',
});
